import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@ot/shared/model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  Environment,
  EnvironmentConfigService,
  PlatformServiceName
} from '../environment';
import { UserService } from '../user';
import {
  APIGetDistanceByJurisdictionReportResponse,
  APIGetReportRequest,
  DistanceByJurisdictionData
} from './report.model';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  apiUrl: string;

  constructor(
    @Inject(ENVIRONMENT) environment: Environment,
    environmentConfigService: EnvironmentConfigService,
    private userService: UserService,
    private http: HttpClient
  ) {
    this.apiUrl =
      environmentConfigService.getEnvironmentConfigs().apis.platform.url +
      '/' +
      environment.serviceUrlList[PlatformServiceName.ReportingService];
  }

  getDistanceByJurisdictionReports(
    startDate: string,
    endDate: string,
    jurisdictions: string[],
    vehicles: string[]
  ): Observable<DistanceByJurisdictionData[]> {
    const businessAccountId = this.userService.getBusinessAccount();
    const request: APIGetReportRequest = {
      businessAccountId: { value: businessAccountId },
      startDate,
      endDate,
      jurisdictions,
      vehicles
    };
    return this.http
      .post(`${this.apiUrl}/distance-by-jurisdiction-reports:search`, request)
      .pipe(
        map((response: APIGetDistanceByJurisdictionReportResponse) => {
          return response.report;
        })
      );
  }
}
